import React from "react";
import { useHistory } from "react-router-dom";

import { Page } from "modules/layout/Page";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "components/Table";
import firebase from "firebaseFactory";
import { useFirebaseListFunction } from "hooks";
import { DeviceReference } from "modules/devices";

export const AdminDevicesPage = ({
  getAllDevices = firebase.function("getAllDevices"),
}) => {
  const history = useHistory();
  const { data: devices, isLoading } = useFirebaseListFunction<DeviceReference>(
    getAllDevices
  );

  return (
    <Page isLoading={isLoading}>
      <h2 className="text-xl font-bold leading-tight pt-10 pb-5">
        All Configured Devices
      </h2>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>Site Id</TableHeaderCell>
            <TableHeaderCell>Unit Id</TableHeaderCell>
            <TableHeaderCell>Device Id</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {devices &&
            devices.map((device, index) => (
              <TableRow
                key={index}
                className="cursor-pointer hover:bg-gray-100"
                onClick={() =>
                  history.push(`/admin/devices/edit/${device.deviceId}`)
                }
              >
                <TableCell nowrap>{device.siteId}</TableCell>
                <TableCell nowrap>{device.unitId}</TableCell>
                <TableCell>{device.deviceId}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Page>
  );
};
